import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (e2) { setErr(formatErr(e2)); }
    setBusy(false);
  };

  return (
    <AuthShell title="Forgot password" subtitle="We'll email you a link to reset it">
      {sent ? (
        <p data-testid="forgot-success" className="text-sm bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-4">
          If an account exists for <b>{email}</b>, a reset link has been sent. Check your inbox (and spam folder).
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Input data-testid="forgot-email-input" type="email" required placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
          {err && <p data-testid="forgot-error" className="text-sm text-red-600">{err}</p>}
          <Button data-testid="forgot-submit-btn" disabled={busy} className="w-full h-11 bg-sky-600 hover:bg-sky-700">Send reset link</Button>
        </form>
      )}
      <Link to="/login" data-testid="back-to-login-link" className="text-sm text-sky-700 hover:underline">Back to sign in</Link>
    </AuthShell>
  );
}
